import type { ComboboxItem } from '@/components/combobox'
import { Combobox } from '@/components/combobox'
import React, { useMemo } from 'react'
import type { AbsenceImportColumn } from '../types'

interface Props {
  label: string
  value: number | null | undefined
  columns: AbsenceImportColumn[]
  placeholder: string
  onChange(value: number | null): void
}

export function MappingSelect({
  label,
  value,
  columns,
  placeholder,
  onChange,
}: Props) {
  const items = useMemo<ComboboxItem<string>[]>(
    () =>
      columns.map(column => ({
        value: String(column.index),
        label: column.label,
        filterValue: column.label,
      })),
    [columns]
  )

  return (
    <label className="grid gap-1 text-sm text-stone-700">
      <span className="font-medium">{label}</span>

      <Combobox
        mode="single"
        value={value == null ? '' : String(value)}
        items={items}
        placeholder={placeholder}
        clearable
        onChange={nextValue => {
          if (nextValue === '') {
            onChange(null)
            return
          }

          const parsed = Number(nextValue)
          onChange(Number.isNaN(parsed) ? null : parsed)
        }}
      />
    </label>
  )
}
